export default __webpack_public_path__ + "static/media/Transfer.b0128828.svg";